<template>
  <div id="app">
    <router-view/>
    <notifications position="top center" classes="my-notification" width="100%" group="form" />
    <drop-shadow />
  </div>
</template>

<style lang="scss" src="./styles/index.scss"></style>

<script>
    import DropShadow from "./components/DropShadow";
    export default {
        components: {DropShadow}
    }
</script>